import React from 'react';
import { motion } from 'framer-motion';

import { technologies } from '../data/techData';
import Skills from './Skills';

const zoomInVariants = {
	hidden: {
		opacity: 0,
		scale: 0,
	},
	visible: {
		opacity: 1,
		scale: 1,
		transition: { delay: 0.2, duration: 0.6 },
	},
};

function Tech() {
	const { proLanguages, UI, webFramesWork, concepts, hosting, CICD } =
		technologies;

	return (
		<div id="techs" className="max-w-screen-2xl h-fit mx-auto my-36">
			<div className="w-11/12 mx-auto flex flex-col justify-center items-center gap-4">
				<h2 className="text-2xl xs:text-3xl sm:text-5xl font-bold">
					Technologies
				</h2>
				<p className="font-medium text-center">
					I've worked with the below technologies in web development world.
				</p>
			</div>
			<div className="w-11/12 mx-auto flex flex-col justify-center items-center">
				<motion.p
					variants={zoomInVariants}
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true }}
					className="text-gray text-2xl font-bold tracking-[2px] my-8"
				>
					Frontend
				</motion.p>

				<div className="w-11/12 lg:w-[97%] xl:w-11/12 mx-auto grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-4 lg:gap-0 lg:flex lg:flex-row lg:justify-between">
					<motion.div
						variants={zoomInVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						className="flex flex-col justify-start items-center"
					>
						<p className="font-bold text-lg mb-5 text-sky-blue text-center">
							Programming Languages
						</p>
						{proLanguages.map((el, index) => (
							<Skills key={index} skills={el} />
						))}
					</motion.div>

					<motion.div
						variants={zoomInVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						className="flex flex-col justify-start items-center"
					>
						<p className="font-bold text-lg mb-5 text-sky-blue text-center">
							UI
						</p>
						{UI.map((el, index) => (
							<Skills key={index} skills={el} />
						))}
					</motion.div>

					<motion.div
						variants={zoomInVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						className="flex flex-col justify-start items-center"
					>
						<p className="font-bold text-lg mb-5 text-sky-blue text-center">
							Web Tools/Frameworks
						</p>
						{webFramesWork.map((el, index) => (
							<Skills key={index} skills={el} />
						))}
					</motion.div>

					<motion.div
						variants={zoomInVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						className="flex flex-col justify-start items-center"
					>
						<p className="font-bold text-lg mb-5 text-sky-blue text-center">
							Concepts
						</p>
						{concepts.map((item, index) => (
							<ul key={index}>
								<li className="w-fit mb-3 flex flex-row justify-between items-center text-center">
									{item}
								</li>
							</ul>
						))}
					</motion.div>

					<motion.div
						variants={zoomInVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						className="flex flex-col justify-start items-center"
					>
						<p className="font-bold text-lg mb-5 text-sky-blue text-center">
							Hosting
						</p>
						{hosting.map((el, index) => (
							<Skills key={index} skills={el} />
						))}
					</motion.div>
					<motion.div
						variants={zoomInVariants}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						className="flex flex-col justify-start items-center"
					>
						<p className="font-bold text-lg mb-5 text-sky-blue text-center">
							CI/CD
						</p>
						{CICD.map((el, index) => (
							<Skills key={index} skills={el} />
						))}
					</motion.div>
				</div>
			</div>
		</div>
	);
}

export default Tech;
